<template>
  <iframe  src="static/newenergy/新能源汽车-.html" width="100%" height="1000px"></iframe>
</template>
<script>
    export default {
        name: "NewEnergy"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/supplychain/components/NewEnergy.vue